import { DataSnapshot } from 'firebase/database'

import { UnreadCountsEnum } from '../models/UnreadCountsEnum'
import { UnreadCountRepository } from '../repositories/UnreadCountRepository'

export function GetUnreadCountCase(
  unreadCountRepository: UnreadCountRepository
) {
  return function (params: {
    profileId: string
    countPath: UnreadCountsEnum
    onValue: (snapshot: DataSnapshot) => unknown
  }) {
    return unreadCountRepository.getUnreadCount(params)
  }
}
